export const basePath = '/appointment'

const optionalParam = (value: string | null | undefined): string =>
  value ? `${value}/` : ''

export const selectAppointmentTypePath = ({ category }: { category: string }) =>
  `${basePath}/${category}`

export const calculateBMIPath = ({
  appointmentType,
  category,
  doctorId,
  locationId,
}: {
  category: string
  appointmentType: string
  locationId?: string
  doctorId?: string
}) =>
  `${basePath}/${category}/${appointmentType}/${optionalParam(locationId)}${optionalParam(doctorId)}bmi-calculator`

export const selectHealthWarningPath = ({
  appointmentType,
  category,
  doctorId,
  locationId,
}: {
  category: string
  appointmentType: string
  locationId?: string
  doctorId?: string
}) =>
  `${basePath}/${category}/${appointmentType}/${optionalParam(locationId)}${optionalParam(doctorId)}health-warning`

export const selectBMIHighPath = ({
  appointmentType,
  bmi,
  category,
  doctorId,
  locationId,
}: {
  category: string
  appointmentType: string
  bmi: number
  locationId?: string
  doctorId?: string
}) =>
  `${basePath}/${category}/${appointmentType}/${optionalParam(locationId)}${optionalParam(doctorId)}bmi-high/${bmi}`

export const selectClinicPath = ({
  appointmentType,
  category,
}: {
  category: string
  appointmentType: string
}) => `${basePath}/${category}/${appointmentType}`

export const selectDateTimePath = ({
  appointmentType,
  category,
  doctorId,
  locationId,
}: {
  category: string
  appointmentType: string
  locationId: string
  doctorId: string
}) => `${basePath}/${category}/${appointmentType}/${locationId}/${doctorId}`

export const selectDoctorPath = ({
  appointmentType,
  category,
  locationId,
}: {
  category: string
  appointmentType: string
  locationId: string
}) => `${basePath}/${category}/${appointmentType}/${locationId}`

export const confirmBookingPath = ({
  appointmentType,
  category,
  doctorId,
  locationId,
}: {
  category: string
  appointmentType: string
  locationId: string
  doctorId: string
}) =>
  `/appointment/${category}/${appointmentType}/${locationId}/${doctorId}/confirm-booking`

export const proposedAppointmentPath = ({
  appointmentType,
  category,
  doctorId,
  locationId,
}: {
  category: string
  appointmentType: string
  locationId: string
  doctorId: string
}) =>
  `${basePath}/${category}/${appointmentType}/${locationId}/${doctorId}/proposed-appointment`

export const patientDetailsPath = () => `${basePath}/patient-details`
